"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Case = exports.CaseItem = exports.If = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var comparison_1 = require("../util/comparison");
// TODO: Spec lists "Conditional", but it's "If" in the XSD
var If = /** @class */ (function (_super) {
    __extends(If, _super);
    function If(json) {
        var _this = _super.call(this, json) || this;
        _this.condition = (0, builder_1.build)(json.condition);
        _this.th = (0, builder_1.build)(json.then);
        _this.els = (0, builder_1.build)(json.else);
        return _this;
    }
    If.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.condition.execute(ctx)];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, this.th.execute(ctx)];
                        }
                        else {
                            return [2 /*return*/, this.els.execute(ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return If;
}(expression_1.Expression));
exports.If = If;
var CaseItem = /** @class */ (function () {
    function CaseItem(json) {
        this.when = (0, builder_1.build)(json.when);
        this.then = (0, builder_1.build)(json.then);
    }
    return CaseItem;
}());
exports.CaseItem = CaseItem;
var Case = /** @class */ (function (_super) {
    __extends(Case, _super);
    function Case(json) {
        var _this = _super.call(this, json) || this;
        _this.comparand = (0, builder_1.build)(json.comparand);
        _this.caseItems = json.caseItem.map(function (ci) { return new CaseItem(ci); });
        _this.els = (0, builder_1.build)(json.else);
        return _this;
    }
    Case.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.comparand) {
                    return [2 /*return*/, this.exec_selected(ctx)];
                }
                else {
                    return [2 /*return*/, this.exec_standard(ctx)];
                }
                return [2 /*return*/];
            });
        });
    };
    Case.prototype.exec_selected = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var val, _i, _a, ci, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.comparand.execute(ctx)];
                    case 1:
                        val = _c.sent();
                        _i = 0, _a = this.caseItems;
                        _c.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        ci = _a[_i];
                        _b = comparison_1.equals;
                        return [4 /*yield*/, ci.when.execute(ctx)];
                    case 3:
                        if (_b.apply(void 0, [_c.sent(), val])) {
                            return [2 /*return*/, ci.then.execute(ctx)];
                        }
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, this.els.execute(ctx)];
                }
            });
        });
    };
    Case.prototype.exec_standard = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, ci;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.caseItems;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        ci = _a[_i];
                        return [4 /*yield*/, ci.when.execute(ctx)];
                    case 2:
                        if (_b.sent()) {
                            return [2 /*return*/, ci.then.execute(ctx)];
                        }
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, this.els.execute(ctx)];
                }
            });
        });
    };
    return Case;
}(expression_1.Expression));
exports.Case = Case;
//# sourceMappingURL=conditional.js.map